import { css } from '@emotion/react'

const dropdownContainer = css`
  & > * {
    width: 100%;
  }
`

const search = css`
  width: 100%;
`
const field = theme => css`
  width: 100%;
  font-size: ${theme.fontSize.large};
  line-height: ${theme.lineHeight.leadingNormal};
  color: ${theme.color.monochrome.mediumDark};
  padding: 7px 12px;
  border: 1px solid ${theme.color.monochrome.medium};
  border-radius: 6px;
  transition: all 0.2s;
  cursor: text;
  min-height: 40px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  &:hover {
    border-color: ${theme.color.primary.brand};
  }
`

const tags = theme => css`
  color: ${theme.color.primary.brand};
  margin: -2px;

  & > * {
    margin: 2px;
  }
`

const dropdown = css`
  width: 240px;
  left: 0 !important;
  right: unset !important;
`

const footerBtns = css`
  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  svg {
    width: 18px;
    height: 18px;
    margin-bottom: 1px;
  }
`

export const styles = {
  search,
  dropdownContainer,
  field,
  tags,
  dropdown,
  footerBtns,
}
